"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const Styles = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement("rect", { width: 16, height: 8, x: 2, y: 2, fill: "#242C39", rx: 1 }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 7h11a1 1 0 011 1v3a1 1 0 01-1 1H8v9a1 1 0 001 1h2a1 1 0 001-1v-7h7a3 3 0 003-3V8a3 3 0 00-3-3H8v2z"
      }
    ),
    /* @__PURE__ */ React.createElement("path", { fill: "#FF6161", d: "M2 3a1 1 0 011-1h3v8H3a1 1 0 01-1-1V3z" }),
    /* @__PURE__ */ React.createElement("path", { fill: "#FFB961", d: "M6 2h4v8H6z" }),
    /* @__PURE__ */ React.createElement("path", { fill: "#00C5B8", d: "M10 2h4v8h-4z" }),
    /* @__PURE__ */ React.createElement("path", { fill: "#716BF1", d: "M14 2h3a1 1 0 011 1v6a1 1 0 01-1 1h-3V2z" })
  );
};
export default Styles;
